import { ReadFile } from '@paragon/client-tools';

import { DesignService } from '../connections';

export function postParseSortingFile(sortingFile: ReadFile): Promise<string[]> {
  return DesignService.post('sortingFiles/parse', {
    data: {
      filename: `${sortingFile.filename}.${sortingFile.filetype}`,
      contents: sortingFile.contents,
    },
  });
}
